export const MINIMUM_LOAN_VALUE = 100000;

/**
 * Returns true if the borrower or coborrower has an eligible Veteran Status
 *
 * @param {*} model
 */
const isVeteranEligible = (model) => {
  const borrowerVeteranStatus = model.getIn(['borrower', 'vaQualification']);
  const coborrowerVeteranStatus = model.getIn(['coborrower', 'vaQualification']);

  if (
    (borrowerVeteranStatus && borrowerVeteranStatus !== 'Ineligible') ||
    (coborrowerVeteranStatus && coborrowerVeteranStatus !== 'Ineligible')
  ) {
    return true;
  }

  return false;
};

/**
 * Returns the loan size based on the questionnaire type and its
 *   associated fields (purchasePrice - downPayment for purchase,
 *   propertyValue + cashOutValue for refi)
 *
 * @param {*} model
 */
export const getLoanAmount = (model) => {
  const scenario = model.getIn(['loan', 'scenario']);
  // purchasePrice is used for both refi and purchase to store the
  //    property value.
  const propertyValue = model.getIn(['loan', 'purchasePrice']) || 0;

  switch (scenario) {
    case 'RefiFull':
    case 'RefiQualify':
      // cashOut must be added to property value
      // Only fetch it if it's a cashout loan (field is not cleared)
      //   automatically
      const cashOut =
        model.getIn(['loan', 'refiPurpose']) === 'CashOut'
          ? model.getIn(['loan', 'cashOutValue']) || 0
          : 0;
      return propertyValue + cashOut;
    default:
      // downPayment must be subtracted from purchase price
      const downPayment = model.getIn(['loan', 'downPayment']) || 0;
      return propertyValue - downPayment;
  }
};

/**
 * Returns true if the total loan value from purchasePrice and
 *   downPayment is greater than MINIMUM_LOAN_VALUE.
 *
 * @param {*} model
 */
export const isPurchaseLargeEnough = (model) => {
  const scenario = model.getIn(['loan', 'scenario']);
  //We do not want to filter out these borrowers as they have already established a relationship
  if (scenario === 'Qualify') {
    return true;
  }

  // Allow Veterans through with any loanSize, but only in Purchase scenario
  if (scenario !== 'Preapproval' && isVeteranEligible(model)) {
    return true;
  }

  return getLoanAmount(model) > MINIMUM_LOAN_VALUE;
};

/**
 * Checks if the loan value is below MINIMUM_LOAN_VALUE. Always returns
 *   true if hasSecondaryLoans is set.
 *
 * @param {*} model
 */
export const isRefinanceLargeEnough = (model) => {
  const scenario = model.getIn(['loan', 'scenario']);
  // We do not want to filter out these borrowers as they have already established a relationship
  if (scenario === 'RefiQualify') {
    return true;
  }

  // Allow Veterans through with any loanSize
  if (isVeteranEligible(model)) {
    return true;
  }
  // This field is set to true if the user indicates they have
  //    a secondary mortgage or HELLOC on the property.
  const hasSecondaryLoans = model.getIn(['loan', 'refiLiens']);
  const loanAmount = getLoanAmount(model);
  return hasSecondaryLoans || loanAmount > MINIMUM_LOAN_VALUE;
};



// WEBPACK FOOTER //
// ./src/modules/loan-size.js